import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReferenceFigures } from '../../../../../common/model/output/scores/reference-figures/types';
import { noopCallback, useGetData } from '../../../../api/common/hooks';
import { fetchProductReferenceFigures } from '../../../../api/model/output/scores';
import { storeReferenceFigures } from '../../../../untidy/redux/actions/actions';
import { getVersionAndReleaseIfExists } from '../../../../untidy/redux/selectors';

export function useLoadReferenceFigures() {
  const { version } = useSelector(getVersionAndReleaseIfExists);
  const { data: productReferenceFigures } = useGetData(
    version ? async () => await fetchProductReferenceFigures(version) : noopCallback,
    [version],
  );
  const dispatch = useDispatch();
  useEffect(() => {
    // moved this not particularily elegant logic from app.tsx
    // to here -- JO 26.8.2020
    if (!productReferenceFigures) {
      return;
    }

    const referenceFigures: ReferenceFigures = {
      product: productReferenceFigures,
    };

    dispatch(storeReferenceFigures(referenceFigures));
  }, [productReferenceFigures]);
}
